import Animate from 'animate.css'
import Vue from 'vue'

Vue.use(Animate)